import { withErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Menu, OpenMenu } from 'autogen/translation-keys/trans-website-shared';
import { Button } from 'components/Button';
import useDrawer from 'components/generic/Drawer/hooks/useDrawer';
import Icon from 'components/Icon';
import { breakpoint } from 'variables';
import SideMenuOpener from './SideMenuOpener';
import { SIDE_MENU_ID } from './shared/constants';

const StyledText = styled.span`
    display: none;
    margin-left: 8px;

    ${breakpoint.up('375px')} {
        display: flex;
    }
`;

function SideMenuOpenerButton() {
    const { open } = useDrawer(SIDE_MENU_ID);
    const { t } = useTranslation();

    return (
        <SideMenuOpener>
            <Button aria-label={t(OpenMenu)} onClick={open} variant="secondary">
                <Icon type="Menu" size={16} />
                <StyledText>{t(Menu)}</StyledText>
            </Button>
        </SideMenuOpener>
    );
}

export default withErrorBoundary(SideMenuOpenerButton, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
